/**
 * BookingVehicleSection - Display and edit vehicle selection
 */
import React from 'react';
import { Car, Edit2 } from 'lucide-react';
import { useVehicleTypes, VehicleIcon, VEHICLE_TYPE_COLORS } from '../../../hooks/useVehicleTypes';

const BookingVehicleSection = ({
  editData,
  setEditData,
  editMode,
  setEditMode,
  canEdit
}) => {
  const { activeVehicleTypes, getVehicleTypeConfig } = useVehicleTypes();

  return (
    <div 
      className={`bg-[#0B0B0B] rounded-lg p-2.5 sm:p-3 ${canEdit ? 'cursor-pointer hover:border-[#C9A24D]/50 border border-transparent active:bg-[#0B0B0B]/80' : ''}`}
      onClick={() => canEdit && editMode !== 'vehicle' && setEditMode('vehicle')}
      data-testid="vehicle-section"
    >
      <div className="flex items-center justify-between mb-2">
        <p className="text-[#E5E5E5]/50 text-[10px] sm:text-xs uppercase flex items-center gap-1">
          <Car className="w-3 h-3" /> Véhicule
        </p>
        {canEdit && editMode !== 'vehicle' && <Edit2 className="w-3 h-3 text-[#C9A24D]/50" />}
      </div>
      
      {editMode === 'vehicle' ? (
        <div className="grid grid-cols-2 gap-1.5 sm:gap-2" onClick={e => e.stopPropagation()}>
          {activeVehicleTypes.map(vt => {
            const colors = VEHICLE_TYPE_COLORS[vt.vehicle_id] || VEHICLE_TYPE_COLORS['berline'];
            const isSelected = editData.vehicleCategory === vt.vehicle_id;
            
            return (
              <button
                key={vt.vehicle_id}
                onClick={() => setEditData(prev => ({ ...prev, vehicleCategory: vt.vehicle_id }))}
                className={`p-2 sm:p-3 rounded-lg border text-center transition-all ${
                  isSelected
                    ? `border-[#C9A24D] ${colors.bg}`
                    : 'border-[#C9A24D]/20 hover:border-[#C9A24D]/50'
                }`}
                data-testid={`vehicle-option-${vt.vehicle_id}`}
              >
                <div className={`w-8 h-8 sm:w-10 sm:h-10 mx-auto rounded-full ${colors.bg} flex items-center justify-center mb-1.5 sm:mb-2`}>
                  <VehicleIcon vehicleType={vt.vehicle_id} size={20} className="w-5 h-5 sm:w-6 sm:h-6" />
                </div>
                <p className={`text-xs sm:text-sm font-medium ${isSelected ? 'text-[#C9A24D]' : 'text-[#E5E5E5]'}`}>
                  {vt.name}
                </p>
                <p className="text-[#E5E5E5]/40 text-[8px] sm:text-[10px] mt-0.5 leading-tight">
                  {vt.max_passengers} pax • {vt.max_luggage} bag
                </p>
              </button>
            );
          })}
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <div className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full ${VEHICLE_TYPE_COLORS[editData.vehicleCategory]?.bg || 'bg-gray-500/20'} flex items-center justify-center`}>
            <VehicleIcon vehicleType={editData.vehicleCategory} size={16} />
          </div>
          <span className="text-[#E5E5E5] text-sm sm:text-base">
            {getVehicleTypeConfig(editData.vehicleCategory)?.label || editData.vehicleCategory}
          </span>
        </div>
      )}
    </div>
  );
};

export default BookingVehicleSection;
